import { BREAKPOINTS } from './constant'
import { Breakpoints, BreakpointType, useBreakpoint } from './useBreakpoint'

export const createUseIsBreakpointX = (breakpoint: Breakpoints) => {
  return (): boolean => {
    const { screenIs } = useBreakpoint()
    return screenIs(breakpoint) === true
  }
}

export const useIsBreakpointSmall = createUseIsBreakpointX(BREAKPOINTS.Small)
export const useIsBreakpointMedium = createUseIsBreakpointX(BREAKPOINTS.Medium)
export const useIsBreakpointLarge = createUseIsBreakpointX(BREAKPOINTS.Large)

export const createUseIsBreakpointXAndUp = (breakpoint: Breakpoints, allBreakpoints: BreakpointType = BREAKPOINTS) => {
  return (): boolean | undefined => {
    const { screenSize } = useBreakpoint()
    const breakpointList = Object.values(allBreakpoints)
    if (typeof screenSize === 'undefined') {
      return undefined
    }
    return breakpointList.splice(breakpointList.indexOf(breakpoint), breakpointList.length).includes(screenSize)
  }
}

export const useIsBreakpointSmallAndUp = createUseIsBreakpointXAndUp(BREAKPOINTS.Small)
export const useIsBreakpointMediumAndUp = createUseIsBreakpointXAndUp(BREAKPOINTS.Medium)
export const useIsBreakpointLargeAndUp = createUseIsBreakpointXAndUp(BREAKPOINTS.Large)
